module.exports = __webpack_public_path__ + "static/analytics-04-min-a724451caa83a9c05a6ced5be8815d19.jpg";